<!-- eslint-disable vue/no-v-html -->
<template>
  <ul class="index-list">
    <li
      v-for="li in indexArr"
      :key="li.name"
      class="index-item"
    >
      <div class="index-header" :class="selectedIndLvl1 === li.name && 'selected-filter'">
        <a :href="li.link" class="link" @click="() => optionSelected()">
          {{ li.name }}
        </a>
        <div
          v-if="li.subthemes.length !== 0"
          class="icon-chevron"
          :class="selectedIndLvl1 === li.name && 'open-filter'"
          @click="changeSelectedTheme(li.name)"
        />
      </div>
      <ul v-if="selectedIndLvl1 === li.name" class="index-list childrens-lvl2">
        <li v-for="li2 in li.subthemes" :key="li2.name" class="index-item">
          <div class="index-header" :class="selectedIndLvl2 === li2.name && 'selected-filter'">
            <a :href="li2.link" class="link" @click="() => optionSelected()">
              {{ li2.name }}
            </a>
            <div
              v-if="li2.subthemes.length !== 0"
              class="icon-chevron"
              :class="selectedIndLvl2 === li2.name && 'open-filter'"
              @click="changeSelectedSubtheme(li2.name)"
            />
          </div>
          <ul v-if="selectedIndLvl2 === li2.name" class="index-list childrens-lvl3">
            <li v-for="li3 in li2.subthemes" :key="li3.name">
              <div class="index-item">
                <div class="index-header">
                  <a :href="li3.link" class="link" @click="() => optionSelected()">
                    {{ li3.name }}
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  components: {},
  directives: {},
  props: {
    indexArr: {
      type: Array,
    },
  },
  data() {
    return {
      selectedIndLvl1: null,
      selectedIndLvl2: null,
    }
  },
  methods: {
    changeSelectedTheme(theme) {
      if (this.selectedIndLvl1 === theme) {
        this.selectedIndLvl1 = null
        this.selectedIndLvl2 = null
      } else {
        this.selectedIndLvl1 = theme
        this.selectedIndLvl2 = null
      }
    },
    changeSelectedSubtheme(theme) {
      if (this.selectedIndLvl2 === theme) {
        this.selectedIndLvl2 = null
      } else {
        this.selectedIndLvl2 = theme
      }
    },
    optionSelected() {
      this.$emit('option-selected')
    }
  },
}
</script>

<style lang="stylus" scoped>
.index-list
  .index-list
    margin-bottom: vw(5px)
    padding-bottom: vw(5px)
    border-bottom: 1px solid $grey-grey

  .index-header
    display: flex
    justify-content: space-between
    align-items: center
    padding: vw(4px) vw(6px)
    width: 100%
    border-radius: 6px

    &.selected-filter
      background-color: $light-grey

  .icon-chevron
    m-icon("chevron-down", 24)
    cursor: pointer
    animation: 0.3s

    &.open-filter
      transform: rotate(180deg)
      animation-name: rotate

  .childrens-lvl2
    margin-top: vw(5px)
    padding-left: vw(15px)

  .childrens-lvl3
    padding-left: vw(30px)

  .link
    m-font-size(14, 20)
    display: block
    color: $black
    font-weight: 400
    curor: pointer

    &:hover
      text-decoration: underline
      
@keyframes rotate
  from
    transform: rotate(0)

  to
    transform: rotate(180deg)
</style>
